const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectTypeCircleSeagrassRestoration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#69C1DD",
    style: {
      stroke: "#69C1DD",
      stroke: "color(display-p3 0.4118 0.7569 0.8667)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2004_4259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76444 24.0125C9.60117 21.1387 8.99224 18.263 7.93651 15.3838C7.69901 14.736 8.52333 14.2307 8.99279 14.7363C10.0462 15.8707 10.9061 17.0393 11.5714 18.2411C11.2094 15.8386 10.6259 13.2944 9.82017 10.6087C9.63793 10.0013 10.3642 9.53401 10.8415 9.95164C12.9009 11.7536 14.3545 14.183 15.2062 17.227C16.3198 13.3513 18.3726 9.98106 21.3629 7.12664C21.8429 6.66851 22.6142 7.16516 22.3959 7.79163C20.9362 11.9804 19.941 15.6997 19.4087 18.9468C20.3336 17.4714 21.63 16.0481 23.2932 14.6785C23.82 14.2446 24.5653 14.8384 24.2601 15.4488C22.8293 18.3104 22.021 21.1637 21.8315 24.0125H26.2224C26.5714 24.0125 26.8543 24.2954 26.8543 24.6444C26.8543 24.9934 26.5714 25.2763 26.2224 25.2763H6.00225C5.65326 25.2763 5.37036 24.9934 5.37036 24.6444C5.37036 24.2954 5.65326 24.0125 6.00225 24.0125H9.76444ZM17.6855 24.0125C17.6965 20.2299 18.5623 15.6143 20.2787 10.1587C17.197 13.9615 15.6011 18.5721 15.487 24.0125H17.6855ZM14.5483 20.2357C14.1033 17.2095 13.166 14.7315 11.7395 12.7904C12.7817 16.8547 13.2953 20.5951 13.2783 24.0126H14.223C14.2493 22.7066 14.3577 21.4476 14.5483 20.2357ZM10.1683 18.341C10.64 20.2305 10.9273 22.1212 11.0301 24.0126H11.988C11.8816 22.0506 11.2771 20.1617 10.1683 18.341ZM20.5651 24.0125C20.6957 21.9223 21.1392 19.8344 21.8942 17.7498C20.101 19.7605 19.1351 21.8462 18.9785 24.0125H20.5651Z",
    fill: "#69C1DD",
    style: {
      fill: "#69C1DD",
      fill: "color(display-p3 0.4118 0.7569 0.8667)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2004_4259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4839,
    height: 21.4839,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(5.37085 5.37097)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleSeagrassRestoration);
export default __webpack_public_path__ + "static/media/project-type-circle-seagrass-restoration.2cae8d6bef94b647601737467d785922.svg";
export { ForwardRef as ReactComponent };